import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { View } from 'foundations-components/components/View';
import FeatureCard from 'marketplace-ui-apps-core/details/components/FeatureCard';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { FeatureCardCompatibility } from './FeatureCardCompatibility';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import useRequiredPlansForIntegrationFeatures from 'marketplace-ui-apps-core/details/hooks/useRequiredPlansForIntegrationFeatures';
import { useAppContext } from '../../../context/AppContext';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated only for use with deprecated integrationFeatures
 */
export function IntegrationFeatures({
  integrationFeatures,
  isOpsHubListing,
  onTrackInteraction
}) {
  const appContext = useAppContext();
  const isCustomer = useSelector(getIsCustomer);
  const {
    requiredPlans,
    compatibilityLoading,
    compatibilityError
  } = useRequiredPlansForIntegrationFeatures({
    appContext: appContext === 'admin-preview' ? 'public' : appContext,
    integrationFeatures: integrationFeatures || []
  });
  const featureCompatibilityRequestStatus = getDataFetchingClientRequestState(compatibilityError, compatibilityLoading);
  return /*#__PURE__*/_jsx(Fragment, {
    children: integrationFeatures.map((integrationFeature, index) => {
      const {
        headline,
        text,
        imageUrl,
        hubSpotFeatures
      } = integrationFeature;
      const showFeatureCardCompatibility = hubSpotFeatures.length && isCustomer && isOpsHubListing;

      // @ts-expect-error untyped dependency
      const requiredPlan = requiredPlans && requiredPlans[index];

      // put the deprecated integrationFeature
      // into the format expected by FeatureCard
      const feature = {
        type: 'MARKETPLACE_LISTING',
        title: headline,
        scopeGroups: [],
        description: text,
        imageUrl,
        illustrationKey: '',
        guides: [],
        internal: {
          scopes: []
        }
      };
      return /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FeatureCard, {
          feature: feature,
          onImageClick: () => onTrackInteraction('click integration feature screenshot', {
            section: 'overview'
          }),
          children: /*#__PURE__*/_jsx(LoadingWrapper, {
            requestStatus: featureCompatibilityRequestStatus,
            children: showFeatureCardCompatibility ? /*#__PURE__*/_jsx(FeatureCardCompatibility, {
              onTrackInteraction: onTrackInteraction,
              missingCompatibilityRequirement: requiredPlan
            }) : null
          })
        }, feature.title)
      }, feature.title);
    })
  });
}